import React, { Component } from "react";
import styled from "styled-components";
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import StyleLink from './dev/StyleLink'
import LoadingSpinner from "./dev/LoadingSpinner";
import DigitOdometer from "./dev/DigitOdometer";
import "odometer/themes/odometer-theme-default.css";
import {
    FacebookShareButton,
    TwitterShareButton,
    FacebookIcon,
    TwitterIcon
} from "react-share";

const { REACT_APP_URI = "/" } = process.env;
const theme = createMuiTheme({
    palette: {
      primary: { main: "#de0606"},
    },
    typography: { useNextVariants: true },
  });
class CurrentSubscriber extends Component {
    constructor(props) {
        super(props);
        this.state = {
            channelId: "",
            cover: "",
            avatar: "",
            title: "",
            subscriberCount: 0,
            isLoading: true,
            creator: "媽祖",
            nowSubscribers: 8865252
        };
    }
    componentDidMount() {
        fetch(`${REACT_APP_URI}/accounts/getToken/`, { credentials: "include" })
            .then(res => res.json())
            .then(res =>
                this.props.dispatch({ type: "setToken", token: res.token })
            )
            .then(() => this.getInfo());
    }
    getInfo = () => {
        const {
            user: { token },
            match: {
                params: { creatorId }
            }
        } = this.props;
        this.setState({ isLoading: true });
        fetch(`${REACT_APP_URI}/realtimeInfo/`, {
            method: "post",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({
                infoId: creatorId
            })
        })
            .then(res => {
                if (res.ok) return res.json();
                else if (res.status === 503 || res.status === 500) 
                    throw setTimeout(() => {
                        this.getInfo();
                        // youTube API 有問題，過一陣再重 call
                    }, 3000);
                else throw console.log("error");
            })
            .then(res =>
                this.setState({ ...res, isLoading: false }, () =>
                    this.getSubscribers()
                )
            );
    };
    getSubscribers = () => {
        const {
            state: { channelId },
            props: {
                user: { token }
            }
        } = this;
        fetch(`${REACT_APP_URI}/currentSubscriber/`, {
            method: "post",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": token
            },
            body: JSON.stringify({
                channelId: channelId
            })
        })
            .then(res => {
                if (res.ok) return res.json();
                else if (res.status === 503 || res.status === 500) 
                    throw setTimeout(() => {
                        this.getSubscribers();
                        // youTube API 有問題，過一陣再重 call
                    }, 3000);
                else throw console.log("error");
            })
            .then(({ subscriberCount }) =>
                this.setState({ subscriberCount: subscriberCount }, () => {
                    setTimeout(() => {
                        this.getSubscribers();
                    }, 1000);
                })
            );
    };
    render() {
        const {
            state: {
                isLoading,
                subscriberCount,
                channelId,
                cover,
                avatar,
                title
            },
            props: {
                messages,
                match: {
                    params: { creatorId }
                }
            }
        } = this;
        return (
            <Container>
                {isLoading ? (
                    <LoadingSpinner justifyContentCenter/>
                ) : (
                    <MuiThemeProvider theme={theme}>
                        <Banner img={cover}/>
                        <AvatarWrap>
                            <a href={`https://www.youtube.com/channel/${channelId}`}  target="_blank">
                                <Avatar img={avatar}/>
                            </a>
                            <Title>
                                <div>{title}</div>
                                <div><span>-</span>{messages.realtime_title}</div>
                            </Title>
                        </AvatarWrap>
                        <DigitOdometer
                            value={subscriberCount}
                            format="(,ddd)"
                            theme="default"
                        />
                        <SocialMediaWrap>
                            <StyledFacebookShareButton
                                url={String(window.location)}
                                //url 上線後改網址
                                quote={`${title} - ${messages.realtime_title}`}
                            >
                                <FacebookIcon size={40} round />
                            </StyledFacebookShareButton>
                            <StyledTwitterShareButton
                                url={String(window.location)}
                                title={`${title} - ${messages.realtime_title}`}
                            >
                                <TwitterIcon size={40} round />
                            </StyledTwitterShareButton>
                        </SocialMediaWrap>
                        <ButtonsWrap>
                            <StyleLink to={`/Info/${creatorId}`} weight={100}>
                                <Button color="primary" variant="outlined" size="medium" >
                                    {messages.realtime_detail}
                                </Button>
                            </StyleLink>
                            <a href={`https://www.youtube.com/channel/${channelId}?sub_confirmation=1`}  target='_blank'>
                                <Button color="primary" variant="outlined" size="medium" >
                                    {messages.realtime_subscribe}
                                </Button>
                            </a>
                            <StyleLink to={`/`} weight={100}>
                                <Button color="primary" variant="outlined" size="medium" >
                                    {messages.realtime_search}
                                </Button>
                            </StyleLink>
                        </ButtonsWrap>
                    </MuiThemeProvider>
                )}
            </Container>
        );
    }
}
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 900px;
    min-height: calc(100vh - 72px);
    padding: 0 0 120px 0;
    background-color: #fafafa;
    border-left: 1px solid #e6e6e6;
    @media (max-width: 900px) {
        min-width: 320px;
    }
    .odometer-theme-default {
        width: 900px;
        font-size: 6rem;
        color: #787878;
        @media (max-width: 665px) {
            font-size: 4rem;
        }
        @media (max-width: 400px) {
            font-size: 3rem;
        }
        .odometer-inside {
            display: flex;
            justify-content: center;
        }
    }
`;
const Banner = styled.div`
    position: relative;
    width: 100%;
    height: calc(100vw / 6.2);
    margin-bottom: calc(-100vw / 31);
    background-image: ${({img}) => `url(${img})`};
    background-position: 180px 72px;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: calc(100% - 180px) auto;
    @media (max-width: 1170px){
        background-position: center 72px;
        background-size: contain;
    }
`;
const AvatarWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    /* transform: translateY(calc(-100vw / 31)); */
    font-size: 1.2rem;
    color: #787878;
    z-index: 1000;
`
const Avatar = styled.div`
    display: flex;
    width: 100px;
    height: 100px;
    background-image: ${({img}) => `url(${img})`};
    background-size: contain;
    background-repeat: no-repeat;
    border: 5px solid #fafafa;
    border-radius: 100%;
`
const Title = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 16px 0 8px 0;
    span {
        padding: 0 .3rem;
    }
    @media (max-width: 665px){
        flex-direction: column;
    }
`
const SocialMediaWrap = styled.div`
    display: flex;
    justify-content: space-between;
    width: 90px;
    margin-top: 16px;
`;
const StyledFacebookShareButton = styled(FacebookShareButton)`
    cursor: pointer;
    &:focus {
        outline: none;
    }
`
const StyledTwitterShareButton = styled(TwitterShareButton)`
    cursor: pointer;
    &:focus {
        outline: none;
    }
`
const ButtonsWrap = styled.div`
    display: flex;
    margin-top: 20px;
    span {
        color: rgba(222, 6, 6, 0.8);
    }
    a:nth-child(2) {
        margin: 0 30px;
        @media (max-width: 665px) {
            margin: 0 20px;
        }
        @media (max-width: 400px) {
            margin: 0 10px;            
        }
    }
`
const mapStateToProps = state => {
    return {
        user: state.User,
        messages: state.Messages
    };
};
export default withRouter(connect(mapStateToProps)(CurrentSubscriber));



// WEBPACK FOOTER //
// ./src/CurrentSubscriber.js